Vue.component('ack-manage-my-subscription', {
	delimiters: ['${', '}$'],
	template: '#ack-manage-my-subscription',
	mixins: [languageMixins],
	async created() {
		await this.ensureValidToken();
		this.getSubscriptionDetail();
	},
	mounted() {
		this.setPageIsLoading(false);
	},
	props: {
		currentUser: Object,
	},

	data() {
		return {
			pageId: 'ack-manage-my-subscription',
			isLoading: false,
			modal: null,
			isSubscriptionNotFound: false,
			subscriptions: [],
			currentSubscription: {},
			selectedSubscriptionIndex: 0,
			modalText: {
				title: '',
				subTitle: '',
				activeMethodBtn: {
					text: '',
					method: null,
				},
				closeDialogBtn: {
					text: '',
				},
			},
			modalTexts: {
				editPayment: {
					title: 'Email sent',
					subTitle:
						'We have sent you an e-mail with a secure link to the page where you can update your payment details.',
					activeMethodBtn: {
						text: '',
						method: null,
					},
					closeDialogBtn: {
						text: 'Okay',
					},
				},
				cancelSubscription: {
					doubleCheck: {
						title: 'Are you sure you want to unsubscribe?',
						subTitle:
							"Your automatic subscription will be terminated and you won't receive any future invoices or get charged automatically.",
						activeMethodBtn: {
							text: 'Cancel it',
							method: null,
						},
						closeDialogBtn: {
							text: 'return',
						},
					},
					success: {
						title: 'Successful',
						subTitle: 'Subscription is canceled.',
						activeMethodBtn: {
							text: null,
						},
						closeDialogBtn: {
							text: 'Okay',
						},
					},
				},
				failedResponse: {
					title: 'Failed',
					subTitle: 'Something went wrong, please contact us.',
					activeMethodBtn: {
						text: null,
					},
					closeDialogBtn: {
						text: 'return',
					},
				},
			},
			ackToken: null,
			tokenExpiredTime: null,
			apiBase: 'https://server-n1.ackuretta.com:9527/api/eshop/seal_subscriptions',
		};
	},
	computed: {
		isStatusActive() {
			return this.currentSubscription.subscriptionStatus === 'ACTIVE';
		},
	},
	methods: {
		formatDate(dateStr) {
			const [y, m, d] = dateStr.split('T')[0].split('-');
			return `${d}/${m}/${y}`;
		},
		formatStatus(status) {
			return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
		},
		formatSubscriptionData(data) {
			this.currentSubscription = {
				id: data.id,
				planName: data.item_title,
				billingFrequency: data.billing_interval,
				subscriptionStatus: data.status,
				subscriptionPrice: `${data.currency} ${Number(data.item_price).toFixed(2)}`,
				billingInfo: {
					name: `${data.b_first_name} ${data.b_last_name}`,
					email: this.currentUser.email,
					address: `${data.b_address1}, ${data.b_city}, ${data.b_province}, ${data.b_country}, ${data.b_zip}`,
				},
				paymentInfo: {
					cardLast4: data.card_last_digits,
					nextBillingDate: data.next_payment,
				},
				transactions: data.payment_history,
			};
		},

		async getSubscriptionDetail() {
			try {
				const result = await this.getSubscriptions();

				if (result.subscriptions.length < 1) {
					this.isSubscriptionNotFound = true;
					return;
				}
				this.subscriptions = result.subscriptions;
				this.ackToken = result.ack_token;
				this.setTokenExpiredTime(result.token_exp);
				this.formatSubscriptionData(this.subscriptions[this.selectedSubscriptionIndex]);
			} catch (err) {
				this.isSubscriptionNotFound = true;
			}
		},

		async onEditPaymentClick() {
			this.setPageIsLoading(true);
			const modal = new bootstrap.Modal(document.getElementById('unsubscribeModal'), {});

			try {
				await this.ensureValidToken();
				await this.editPayment();
				this.modalText = this.modalTexts.editPayment;
			} catch (error) {
				this.modalTexts.failedResponse.subTitle = 'Failed to edit payment';
				this.modalText = this.modalTexts.failedResponse;
			} finally {
				this.setPageIsLoading(false);
				modal.show();
			}
		},

		onCancelSubscriptionClick() {
			this.modalText = this.modalTexts.cancelSubscription.doubleCheck;
			this.modalTexts.cancelSubscription.doubleCheck.activeMethodBtn.method =
				this.handleCancelSubscription;

			let modal = new bootstrap.Modal(document.getElementById('unsubscribeModal'), {});
			modal.show();
		},

		async handleCancelSubscription() {
			try {
				this.setPageIsLoading(true);
				this.isLoading = true;
				await this.ensureValidToken();
				await this.cancelSubscription();
				this.modalText = this.modalTexts.cancelSubscription.success;
				await this.getSubscriptionDetail();
			} catch (error) {
				this.modalTexts.failedResponse.subTitle = 'Failed to cancel subscription.';
				this.modalText = this.modalTexts.failedResponse;
			} finally {
				this.isLoading = false;
				this.setPageIsLoading(false);
			}
		},

		onSelectSubscription(subscriptionIndex) {
			this.selectedSubscriptionIndex = subscriptionIndex;
			this.formatSubscriptionData(this.subscriptions[this.selectedSubscriptionIndex]);
		},

		async getSubscriptions() {
			return this.sendSubscriptionRequest({
				method: 'GET',
				endpoint: `/details?user=${this.currentUser.email}&verify=${this.currentUser.id}`,
				failMessage: 'Subscription not found.',
			});
		},
		async getToken() {
			return this.sendSubscriptionRequest({
				method: 'GET',
				endpoint: `/token?user=${this.currentUser.email}&verify=${this.currentUser.id}`,
				failMessage: 'Please login again.',
			});
		},
		async editPayment() {
			return this.sendSubscriptionRequest({
				method: 'PUT',
				endpoint: '/edit_payment',
				payload: {
					id: this.currentSubscription.id,
					ack_token: this.ackToken,
				},
				failMessage: 'Failed to edit payment',
			});
		},
		async cancelSubscription() {
			return this.sendSubscriptionRequest({
				method: 'PUT',
				endpoint: '/cancel_subscription',
				payload: {
					id: this.currentSubscription.id,
					ack_token: this.ackToken,
				},
				failMessage: 'Failed to cancel subscription.',
			});
		},

		async sendSubscriptionRequest({ method, endpoint, payload, failMessage }) {
			const options = {
				method,
			};
			if (method !== 'GET') {
				options.headers = { 'Content-Type': 'application/json' };
				options.body = JSON.stringify(payload);
			}
			const response = await fetch(`${this.apiBase}/${endpoint}`, options);

			const result = await response.json();

			if (result.status_code !== 200) {
				throw new Error(failMessage);
			}

			return result;
		},

		setTokenExpiredTime(tokenValidPeriod) {
			this.tokenExpiredTime = Date.now() + tokenValidPeriod * 1000;
		},
		isTokenExpired() {
			return this.tokenExpiredTime < Date.now();
		},
		async ensureValidToken() {
			if (this.isTokenExpired()) {
				const getTokenResult = await this.getToken();
				this.ackToken = getTokenResult.ack_token;
				this.setTokenExpiredTime(getTokenResult.token_exp);
			}
		},
	},
});
